module.exports = __webpack_public_path__ + "img/logo_am.05afe6db.png";